import { createStore, applyMiddleware, compose } from "redux";
import { persistStore, persistReducer, createTransform } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { thunk } from "redux-thunk";
import rootReducer from "../reducers";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// globalLoader/initialyLoaded are per-session bootstrap flags, not durable user
// state. Persisting them (and, worse, rehydrating a stale "already loaded" from
// a prior session) makes the app skip its initial data fetch and render blank
// until the user clears site storage. This transform strips both keys on the
// way out to storage and on the way back in, so it also cleans up state that
// was already poisoned by an older build.
const userReducerTransform = createTransform(
  (inboundState) => {
    const { globalLoader, initialyLoaded, ...rest } = inboundState;
    return rest;
  },
  (outboundState) => ({
    ...outboundState,
    globalLoader: false,
    initialyLoaded: false,
  }),
  { whitelist: ["userReducer"] }
);

const persistConfig = {
  key: "root",
  storage,
  transforms: [userReducerTransform],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export default () => {
  let store = createStore(
    persistedReducer,
    composeEnhancers(applyMiddleware(thunk))
  );
  let persistor = persistStore(store);
  return { store, persistor };
};
